export const fieldValidators = {
	required: (value) => (value ? undefined : "Required"),
	isSlug: (value) =>
		value.match(/^[a-z0-9-_.]+$/i)
			? undefined
			: "Alphanumeric characters and dashes/underscores only",
};
